import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'supplier-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class SupplierDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/dashboard/dashboard.component.ts